export enum NumeralFormat {
  NULL = '-'
}
